<template>
  <div v-if="user">
    <div class="field">
      <label class="label">ID</label>
      <div class="control">
        <input class="input" type="text" v-model="user.id" disabled />
      </div>
    </div>
    <div class="field">
      <label class="label">Full Name</label>
      <div class="control">
        <input class="input" type="text" v-model="user.full_name" />
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">E-Mail</label>
      </div>
    </div>
    <div class="field has-addons">
      <div class="control">
        <input class="input" type="text" v-model="user.email" />
      </div>
      <div class="control">
        <span class="select">
          <select v-model="user.email_validation">
            <option value="true">Verified</option>
            <option value="false">Not Verified</option>
          </select>
        </span>
      </div>
    </div>

    <div class="field">
      <label class="label">Is Active</label>
      <div class="control">
        <span class="select">
          <select v-model="user.is_active">
            <option value="1">Active</option>
            <option value="0">Passive</option>
          </select>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "UserGeneralTab",
  props: {
    userData: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapState(["selectedUser"]),
    user() {
      // Prefer userData prop, fallback to selectedUser for backward compatibility
      return this.userData || this.selectedUser;
    },
  },
};
</script>

<style></style>
